import React from "react";
import "./Spiner.css"
export default function Spinner(){
    return (
        <div  className=" flex items-center justify-center h-64">
            <div className=" animate-spin rounded-full h-16 w-16  border-t-2 border-b-2 border-blue-500">
                

            </div>
        </div>
    )
}